declare global {
  interface Window {
    fbAsyncInit?: () => void;
    FB?: {
      init: (options: {
        appId: string;
        cookie: boolean;
        xfbml: boolean;
        version: string;
      }) => void;
      login: (
        callback: (response: { authResponse?: { code?: string }; status?: string }) => void,
        options: {
          config_id: string;
          response_type: string;
          override_default_response_type: boolean;
          extras?: Record<string, unknown>;
        }
      ) => void;
    };
  }
}

let sdkLoadingPromise: Promise<void> | null = null;

export function loadFacebookSdk(appId: string, version = "v25.0"): Promise<void> {
  if (typeof window === "undefined") {
    return Promise.reject(new Error("Facebook SDK can only be loaded in the browser"));
  }

  if (!appId) {
    return Promise.reject(new Error("Missing Meta app ID"));
  }

  if (window.FB) {
    return Promise.resolve();
  }

  if (sdkLoadingPromise) {
    return sdkLoadingPromise;
  }

  sdkLoadingPromise = new Promise<void>((resolve, reject) => {
    window.fbAsyncInit = () => {
      if (!window.FB) {
        reject(new Error("Facebook SDK loaded without FB global"));
        return;
      }

      window.FB.init({
        appId,
        cookie: true,
        xfbml: false,
        version,
      });

      resolve();
    };

    const existingScript = document.getElementById("facebook-jssdk");
    if (existingScript) {
      return;
    }

    const script = document.createElement("script");
    script.id = "facebook-jssdk";
    script.async = true;
    script.defer = true;
    script.crossOrigin = "anonymous";
    script.src = "https://connect.facebook.net/pt_BR/sdk.js";
    script.onerror = () => {
      sdkLoadingPromise = null;
      reject(new Error("Failed to load the Facebook SDK"));
    };

    document.body.appendChild(script);
  });

  return sdkLoadingPromise;
}
